import React, { useContext, useEffect, useState } from 'react';
import css from './SelectProducts.module.scss';
import SingleButton from '../../form-control-buttons/SingleButton/SingleButton';
import GridComponent from '../../../grid/GridComponent/GridComponent';
import Plug from '../../../plug/Plug/Plug';
import T from '../../../../common/components/T';
import SelectProductsModal from './components/SelectProductsModal/SelectProductsModal';
import { thead, transformData } from './helpers';
import plug_img from '../../../../public/src/img/plugs/products_empty.svg';
import { LangContext } from '../../../../common/decorators/Language';
import { generateCompStylers } from '../../../../common/utils/styles';
import { FieldError } from '../../../../hybrid/wrappers';
import UserContext from '../../../../common/utils/getContext';
import { getData } from '../../../../common/utils/router';
import classNames from 'classnames';

const SelectProducts = ({
    value,
    setFormData,
    attribute,
    errors,
    compStyle = {},
    customData = {},
    isEditing,
    isOnlyProducts
}) => {
    const { userToken, lang } = useContext(UserContext);
    const { translation } = useContext(LangContext);
    const [allProducts, setAllProducts] = useState([]);
    const { classes } = generateCompStylers(compStyle);

    const [val, setVal] = useState([]);

    const [modal, showModal] = useState(false);
    const quantityHandler = (row, type) => {
        if (type === 'minus') {
            if (+row?.quantity > 1) {
                setFormData(
                    attribute,
                    value?.map((it) => {
                        if (+it?.id === +row?.id) {
                            return {
                                ...it,
                                quantity: it?.quantity - 1
                            };
                        }
                        return it;
                    })
                );
            }
        } else {
            setFormData(
                attribute,
                value?.map((it) => {
                    if (+it?.id === +row?.id) {
                        return {
                            ...it,
                            quantity: it?.quantity + 1
                        };
                    }
                    return it;
                })
            );
        }
    };

    useEffect(() => {
        getData(
            isEditing
                ? '/api/v1/shop/products?page[size]=999'
                : '/api/v1/shop/products?page[size]=999&filter[product_availability]=in_stock,expected_arrival',
            userToken,
            lang
        ).then((res) => {
            setAllProducts(res?.data);
        });
    }, [userToken, lang, isEditing]);

    const inputHandler = (row, v) => {
        setFormData(
            attribute,
            value?.map((it) => {
                if (+it.id === +row?.id) {
                    return {
                        ...it,
                        quantity: +v
                    };
                }
                return it;
            })
        );
    };

    useEffect(() => {
        setVal(
            value
                ?.map((item) => {
                    const finded = allProducts?.find((product) => product.id === item.id);
                    if (finded) {
                        return {
                            ...finded,
                            quantity: item.quantity
                        };
                    }
                })
                .filter((el) => !!el)
        );
    }, [value, allProducts]);

    return (
        <>
            <SingleButton
                type='cancel'
                buttonText={<T textName='choose-products' defaultStr='Выбрать продукты' />}
                icon='plus'
                customButton={{
                    spriteWrapper: css.icon,
                    butText: css.butText,
                    butWrapper: css.butWrapper,
                    singleButton: classNames(css.singleButton, classes?.addBtn)
                }}
                clickFunc={() => showModal(true)}
            />
            {val && val.length ? (
                <GridComponent
                    viewThead={customData.thead || thead}
                    viewData={transformData(translation)({ data: val })}
                    convertData={transformData(translation)}
                    sticky={true}
                    handlers={{
                        actions: {
                            destroy: {
                                onClick: (row) => {
                                    setFormData(
                                        attribute,
                                        value?.filter((it) => +it?.id !== +row?.id)
                                    );
                                }
                            }
                        },
                        quantity: {
                            plus: {
                                onClick: (row) => quantityHandler(row, 'plus')
                            },
                            minus: {
                                onClick: (row) => quantityHandler(row, 'minus')
                            },
                            change: {
                                onChange: (row, setGridData, v, e) => {
                                    const val = e.target.value;
                                    inputHandler(row, val);
                                    // ставимо ширину поля від ширини контента
                                    const newInputWidth = String(val)?.length * 1.4 + 'ch';
                                    if (e && e.target) {
                                        e.target.style.width = newInputWidth;
                                    }
                                }
                            }
                        }
                    }}
                    gridStyles={{
                        gridWrapper: classes?.gridWrapper,
                        tableWrapper: {
                            wrapper: classes?.tableWrapper,
                            stickyTable: classes?.stickyTable
                        }
                    }}
                />
            ) : (
                <Plug
                    plugTitle={<T textName='no_products_added' defaultStr='Не добавлено ни одного продукта' />}
                    plugDescription={
                        <T
                            textName='at_least_one_product_must_be_added_to_the_new_invoice'
                            defaultStr='В новой накладной должен быть добавлен хотя бы один продукт'
                        />
                    }
                    plugImg={plug_img}
                />
            )}
            {errors && errors.length
                ? errors.map((err, idx) => (
                      <FieldError compStyle={compStyle?.error} key={`${attribute}${idx}`}>
                          {err}
                      </FieldError>
                  ))
                : null}
            {modal ? (
                <SelectProductsModal
                    value={value}
                    setFormData={setFormData}
                    closeHandler={() => showModal(false)}
                    attribute={attribute}
                    isOnlyProducts={isOnlyProducts}
                />
            ) : null}
        </>
    );
};

export default SelectProducts;
